import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function SettingRoute({ element }) {
  const { setting } = useSelector((state) => {
    return { setting: state.setting };
  });

  const isSettingAuthenticated = setting?.isAuthenticated;

  if (!isSettingAuthenticated) {
    return <Navigate to="/app/settings" replace />;
  }

  return element;
}
